import React, { FC } from 'react'
import posterThumbnail from '../../../../images/gallerium/onDemand/poster-thumbnail.png'
import videoThumbnail from '../../../../images/gallerium/onDemand/video-thumbnail.png'
import playIcon from '../../../../images/icons/play_circle.png'
import { StyledListItem } from './styled'

interface ListItemType {
  title: string
  subtitle: string
  abstractId: number
  abstractType: 'poster' | 'oral'
}

export const ListItem: FC<ListItemType> = ({ title, subtitle, abstractId, abstractType }) => {
  const abstractInfo = () => {
    switch (abstractType) {
      case 'poster':
        return {
          url: `/gallery/abstracts/${abstractId}`,
          thumbnail: posterThumbnail,
        }
      case 'oral':
        return {
          url: `/gallery/abstracts/${abstractId}`,
          thumbnail: videoThumbnail,
        }
    }
  }

  const { url, thumbnail } = abstractInfo()

  return (
    <StyledListItem to={url}>
      <div className="listThumbnail">
        <img src={thumbnail} alt={abstractType} />
      </div>
      <div className="listContent">
        <div className="title">{title}</div>
        <div className="subtitle">{subtitle.toLowerCase()}</div>
      </div>
      <div className="listAction">
        <img src={playIcon} alt="play" />
      </div>
    </StyledListItem>
  )
}
